import styled from 'styled-components'
import theme from '../../styles/theme'

export const WrapperBox = styled.div<{$isNavbarHidden?: boolean}>`
  display: flex;
  justify-content: center;
  width: 100%;

  ${({$isNavbarHidden}) => ($isNavbarHidden ? `` : `padding-top: 96px;`)}

  ${theme.breakpoints.down('md')} {
    ${({$isNavbarHidden}) => ($isNavbarHidden ? `` : `padding-top: 56px;`)}
  }
`
